import styled from "@xstyled/styled-components";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";

import { palette, pxToRem } from "@otta/design-tokens";
import { LogoHeader } from "@hire/components/layout/QuizLayout";
import { CurrentUserDocument } from "@hire/schema";
import { Loading } from "@otta/shared-components";
import { VideoContent } from "@hire/components/VideoContent";
import { Spacing, Text } from "@otta/design";
import { IconList, IconListItem } from "@hire/components/IconList";

const Main = styled.main`
  background-color: ${palette.brand.white};
  flex-direction: column;
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
`;

const Content = styled.div`
  max-width: ${pxToRem(800)};
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: ${pxToRem(1200)};
  max-width: 100%;
  margin: 0 auto;
`;

export function AboutWTTJ() {
  const navigate = useNavigate();
  const { data, loading } = useQuery(CurrentUserDocument);

  const loggedIn = !!data?.me;

  const handleContinue = () => {
    if (!loggedIn) {
      navigate("/quiz/company");
    } else {
      navigate("/quiz/success");
    }
  };

  const handleBack = () => {
    navigate("/quiz/who-is-startup-for");
  };

  if (loading || !data) {
    return <Loading />;
  }

  return (
    <Main>
      <LogoHeader />
      <PageContainer>
        <div>
          <VideoContent
            title="What is Welcome To The Jungle, and will it help me with my hiring?"
            videoUrl="https://vimeo.com/1101494249"
            videoAnalyticsCategory="Sign-up Quiz - About WTTJ"
            continueButtonText="Continue"
            continueButtonAnalyticsId="what-is-wttj-continue"
            onContinue={handleContinue}
            backButtonText="Back"
            onBack={handleBack}
            backButtonAnalyticsId="what-is-wttj-back"
          >
            <Content>
              <Spacing size={-3}>
                <Text>
                  Welcome to the Jungle is a curated marketplace of the best
                  candidates in the market.
                </Text>
                <Text>Our candidates are:</Text>
                <IconList>
                  <IconListItem icon="checkmark">
                    Discerning and savvy - they do their research
                  </IconListItem>
                  <IconListItem icon="checkmark">
                    Apply for an average of 5 roles before gaining an offer
                  </IconListItem>
                  <IconListItem icon="checkmark">
                    Skeptical of job spec jargon, hazy benefits and incomplete
                    company information
                  </IconListItem>
                  <IconListItem icon="checkmark">
                    Expect transparency, excitement and a genuine career move
                  </IconListItem>
                  <IconListItem icon="checkmark">
                    Matched only to roles aligned with their experience and
                    aspirations
                  </IconListItem>
                </IconList>
              </Spacing>
            </Content>
          </VideoContent>
        </div>
      </PageContainer>
    </Main>
  );
}
